export default __webpack_public_path__ + "static/media/Footer_Playstore.597371be.webp";